/**
 * Best-effort extraction of a readable detail string from an MSAL (or other structured) error,
 * combining errorCode/errorMessage/name fields when present. Used by the SharePoint consent flow
 * to surface the real underlying error (e.g. from @azure/msal-browser) in places where only a
 * generic translated message would otherwise be shown.
 */
export function describeError(error: unknown): string {
    if (error && typeof error === "object") {
        const { errorCode, errorMessage, name, message } = error as Record<string, unknown>;
        const parts = [errorCode, errorMessage ?? message, name].filter(
            (part): part is string => typeof part === "string" && part.length > 0
        );
        if (parts.length > 0) {
            return parts.join(" — ");
        }
    }
    return String(error);
}
